import constants from '../shared/constants';
import requestWrapper from '../shared/lib/requestWrapper';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/patient',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function search(payload) {
    var response = await requestWrapper({
        url:    '/patient/search',
        method: 'POST',
        baseURL: constants.sdn.baseUrl,
        data: payload.data,
        notifications: payload.notifications
    });

    return response
}

const PatientService = {
    search, create
}

export default PatientService;